import styled from 'styled-components';
import color from '../../../config/colors.json';

export const StyledLabel = styled.label`
    font-family: 'Poppins', Arial, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 21px;
    color: ${color.darkGrey};
    margin-bottom: 10px;
    font-weight: 600;
`;

export const StyledH2 = styled.h2`
    font-family: 'Poppins', Arial, Helvetica, sans-serif;
    font-size: 15px;
    line-height: 21px;
    text-align: left;
    color: ${color.darkGrey};
    font-weight: 600;
    margin: 0;
`;
